/*
 * UOKIDS — تجربة الموبايل (2026-10-27). بيتحمّل defer من snippets/uokids-head.
 *
 * 1. شريط التنقل تحت (snippets/uokids-tabbar): بيستخبّى وإنتي نازلة وبيرجع وإنتي طالعة،
 *    و«الأقسام»/«بحث» بيدوسوا على زرار الهيدر نفسه (data-uo-tab-click).
 * 2. «رجوع لـ…» فوق صفحة المنتج (snippets/uokids-trail): بيتنقل لأول الصفحة وبيكتب المكان اللي
 *    العميلة جاية منه فعلًا (قسم/بحث/رئيسية، أو الباقة لو فتحت قطعة منها). لو الصفحة اللي
 *    قبلها هي نفس المكان، «رجوع» بيعمل history.back() فبترجع لنفس مكانها في الصفحة.
 * 3. شيت السلة على الموبايل: سحب لتحت من فوق الشيت بيقفله.
 * 4. «قارني الباقات»: الجدول بيتحرّك على عمود الباقة الحالية.
 * 5. الشيتات (dialog.uo-sheet + data-uo-sheet-open/close/drag): زي شيت السلة بالظبط.
 * 6. شريط الشراء تحت في صفحة المنتج ظاهر طول ما الزرار الأصلي مش قدامك (html.uo-buybar-on).
 * 7. «هيوصلك بين … و…» تحت السعر (blocks/uokids-savings).
 * 8. دواير الأقسام (snippets/uokids-chips): الصف بيتحرّك على القسم الحالي.
 * 9. «اختاري اللون/الشكل» في كروت الرئيسية (data-uo-choose): شيت اختيار سريع + «أضيفي للسلة».
 * 10. نافذة الاختيار السريع بتاعة Horizon: اسحبي لتحت عشان تقفلي.
 */
(function () {
  'use strict';

  var store = {
    get: function (k) {
      try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; }
    },
    set: function (k, v) {
      try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
    },
    del: function (k) {
      try { sessionStorage.removeItem(k); } catch (e) {}
    }
  };
  var page = window.UO_PAGE || {};
  var mobile = window.matchMedia('(max-width: 749px)');

  /* ---------- 1. شريط التنقل ---------- */
  var bar = document.querySelector('[data-uo-tabbar]');
  if (bar) {
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          var dy = y - lastY;
          if (Math.abs(dy) > 6) {
            bar.classList.toggle('is-hidden', dy > 0 && y > 140);
            lastY = y;
          }
          ticking = false;
        });
      },
      { passive: true }
    );
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-uo-tab-click]');
    if (!t) return;
    var target = document.querySelector(t.getAttribute('data-uo-tab-click'));
    if (target) {
      e.preventDefault();
      target.click();
    }
  });

  /* ---------- 2. «رجوع لـ…» ---------- */
  // صفحات القوايم: نفتكرها عشان صفحة المنتج تعرف ترجّع لها
  if (page.type === 'collection' || page.type === 'search' || page.type === 'index' || page.type === 'list-collections') {
    store.set('uo_list', { t: page.title || '', u: location.pathname + location.search });
    store.del('uo_bundle');
  }
  // قطعة من «إيه اللي في الباقة؟»
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-uo-bundle-link]');
    if (!a) return;
    var box = a.closest('[data-uo-bundle-url]');
    if (!box) return;
    store.set('uo_bundle', {
      t: box.getAttribute('data-uo-bundle-title') || '',
      u: box.getAttribute('data-uo-bundle-url') || '',
      s: box.getAttribute('data-uo-bundle-save') || ''
    });
  });

  var trail = document.querySelector('[data-uo-trail]');
  if (trail) {
    var main = document.getElementById('MainContent');
    if (main) main.insertBefore(trail, main.firstChild);
    var link = trail.querySelector('[data-uo-trail-link]');
    var titleEl = trail.querySelector('[data-uo-trail-title]');
    var note = trail.querySelector('[data-uo-trail-note]');
    var ar = (document.documentElement.lang || 'ar').indexOf('ar') === 0;
    var here = location.pathname;
    var b = store.get('uo_bundle');
    var l = store.get('uo_list');
    if (b && b.u && b.u.split('?')[0] !== here) {
      titleEl.textContent = ar ? 'رجوع للعرض' : 'Back to offer';
      link.setAttribute('href', b.u);
      trail.classList.add('uo-trail--bundle');
      if (b.s && note) {
        note.textContent = ar ? 'وفّري ' + b.s + ' ج' : 'Save ' + b.s + ' EGP';
        note.hidden = false;
      }
      link.setAttribute('aria-label', (ar ? 'رجوع إلى ' : 'Back to ') + (b.t || ''));
    } else if (l && l.u) {
      if (l.t) {
        titleEl.textContent = l.t;
        link.setAttribute('aria-label', (ar ? 'رجوع إلى ' : 'Back to ') + l.t);
      }
      link.setAttribute('href', l.u);
    }
    trail.hidden = false;
    link.addEventListener('click', function (e) {
      // لو الصفحة اللي قبل دي هي نفس الهدف، نرجع بالـ history عشان ترجع لنفس مكانها بالظبط
      try {
        var ref = document.referrer ? new URL(document.referrer) : null;
        var to = new URL(link.href, location.href);
        if (ref && ref.origin === location.origin && ref.pathname === to.pathname && history.length > 1) {
          e.preventDefault();
          history.back();
        }
      } catch (err) {}
    });
  }

  /* ---------- 3. شيت السلة: اسحبي لتحت عشان تقفلي ---------- */
  var drawer = document.getElementById('cart-drawer');
  var sheet = drawer && drawer.querySelector('dialog');
  if (sheet) {
    var startY = 0;
    var dy = 0;
    var dragging = false;
    sheet.addEventListener(
      'touchstart',
      function (e) {
        if (!mobile.matches || !sheet.open) return;
        var r = sheet.getBoundingClientRect();
        var y = e.touches[0].clientY;
        // من فوق الشيت بس (المقبض + العنوان) عشان السكرول جوّه يفضل شغال عادي
        if (y - r.top > 76) return;
        if (e.target.closest && e.target.closest('button, a, input')) return;
        dragging = true;
        startY = y;
        dy = 0;
        sheet.style.transition = 'none';
      },
      { passive: true }
    );
    sheet.addEventListener(
      'touchmove',
      function (e) {
        if (!dragging) return;
        dy = Math.max(0, e.touches[0].clientY - startY);
        sheet.style.transform = 'translateY(' + dy + 'px)';
      },
      { passive: true }
    );
    var endDrag = function () {
      if (!dragging) return;
      dragging = false;
      if (dy > 90) {
        sheet.style.transition = '';
        if (typeof drawer.close === 'function') drawer.close();
        else {
          var c = sheet.querySelector('.theme-drawer__close-button');
          if (c) c.click();
        }
        setTimeout(function () { sheet.style.transform = ''; }, 450);
      } else {
        sheet.style.transition = 'transform .22s ease';
        sheet.style.transform = '';
        setTimeout(function () { sheet.style.transition = ''; }, 240);
      }
    };
    sheet.addEventListener('touchend', endDrag);
    sheet.addEventListener('touchcancel', endDrag);
  }

  /* ---------- 4. «قارني الباقات»: روحي على عمود الباقة الحالية ---------- */
  var centerCompare = function (root) {
    (root || document).querySelectorAll('[data-uo-cmp]').forEach(function (box) {
      var cur = box.querySelector('[data-uo-cmp-cur]');
      if (!cur) return;
      var head = box.querySelector('.uo-cmp__corner');
      var bw = box.getBoundingClientRect();
      var cw = cur.getBoundingClientRect();
      var stick = head ? head.getBoundingClientRect().width : 0;
      var visibleCenter = (bw.left + bw.right) / 2 + (document.documentElement.dir === 'rtl' ? -stick / 2 : stick / 2);
      box.scrollLeft += (cw.left + cw.right) / 2 - visibleCenter;
    });
  };
  if (document.readyState === 'complete') centerCompare();
  else window.addEventListener('load', function () { centerCompare(); });

  /* ---------- 5. شيتات UOKIDS (dialog.uo-sheet): بتطلع من تحت، وبتتقفل بالسحب أو برّه أو × ---------- */
  var openSheet = function (dl) {
    if (!dl || dl.open) return;
    dl.classList.remove('is-closing');
    dl.showModal();
    document.documentElement.classList.add('uo-sheet-lock');
    requestAnimationFrame(function () { centerCompare(dl); });
  };
  var closeSheet = function (dl) {
    if (!dl || !dl.open || dl.classList.contains('is-closing')) return;
    dl.classList.add('is-closing');
    setTimeout(function () {
      dl.classList.remove('is-closing');
      dl.style.transform = '';
      dl.close();
    }, 240);
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-uo-sheet-open]');
    if (o) {
      e.preventDefault();
      openSheet(document.getElementById(o.getAttribute('data-uo-sheet-open')));
      return;
    }
    var c = e.target.closest && e.target.closest('[data-uo-sheet-close]');
    if (c) {
      e.preventDefault();
      closeSheet(c.closest('dialog'));
      return;
    }
    // دوسة على الخلفية برّه الشيت
    if (e.target.matches && e.target.matches('dialog.uo-sheet')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) closeSheet(e.target);
    }
  });
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.uo-sheet')) {
      if (!document.querySelector('dialog.uo-sheet[open]')) document.documentElement.classList.remove('uo-sheet-lock');
    }
  }, true);
  document.addEventListener('cancel', function (e) {
    if (e.target.matches && e.target.matches('dialog.uo-sheet')) {
      e.preventDefault();
      closeSheet(e.target);
    }
  }, true);
  // سحب لتحت من مقبض الشيت
  var sd = null;
  document.addEventListener('touchstart', function (e) {
    var h = e.target.closest && e.target.closest('[data-uo-sheet-drag]');
    if (!h || (e.target.closest('button, a'))) return;
    var dl = h.closest('dialog');
    if (!dl) return;
    sd = { dl: dl, y: e.touches[0].clientY, dy: 0 };
    dl.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!sd) return;
    sd.dy = Math.max(0, e.touches[0].clientY - sd.y);
    sd.dl.style.transform = 'translateY(' + sd.dy + 'px)';
  }, { passive: true });
  var sheetEnd = function () {
    if (!sd) return;
    var s2 = sd;
    sd = null;
    s2.dl.style.transition = '';
    if (s2.dy > 90) closeSheet(s2.dl);
    else s2.dl.style.transform = '';
  };
  document.addEventListener('touchend', sheetEnd);
  document.addEventListener('touchcancel', sheetEnd);

  /* ---------- 6. شريط الشراء تحت في صفحة المنتج (موبايل): ظاهر طول ما زرار «أضيفي للسلة» الأصلي مش قدامك ----------
     Horizon بيظهره بس بعد ما تعدّي الزرار؛ هنا بيظهر كمان قبل ما توصليله (الزرار تحت قطع الباقة)،
     وبيستخبّى لما الزرار الأصلي أو الفوتر يبانوا. الشكل في assets/uokids-ux.css (html.uo-buybar-on). */
  var buyBlock = document.querySelector('.product-details .buy-buttons-block');
  if (buyBlock && document.querySelector('.sticky-add-to-cart__bar') && 'IntersectionObserver' in window) {
    var footerEl = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    var buyVisible = true;
    var footVisible = false;
    var syncBar = function () {
      document.documentElement.classList.toggle('uo-buybar-on', mobile.matches && !buyVisible && !footVisible);
    };
    new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting; syncBar(); }).observe(buyBlock);
    if (footerEl) new IntersectionObserver(function (en) { footVisible = en[0].isIntersecting; syncBar(); }).observe(footerEl);
    if (mobile.addEventListener) mobile.addEventListener('change', syncBar);
  }

  /* ---------- 7. «هيوصلك …»: ميعاد التوصيل التقريبي (3 لـ 7 أيام زي «الأسئلة الشائعة»، والجمعة مفيش توصيل) ---------- */
  var isArDoc = (document.documentElement.lang || 'ar').indexOf('ar') === 0;
  var uoEtaHtml = '';
  if (window.Intl) {
    try {
      var tzc = 'Africa/Cairo';
      var fDay = new Intl.DateTimeFormat(isArDoc ? 'ar-EG' : 'en-GB', { weekday: isArDoc ? 'long' : 'short', timeZone: tzc });
      var fD = new Intl.DateTimeFormat('en-US', { day: 'numeric', timeZone: tzc });
      var fM = new Intl.DateTimeFormat('en-US', { month: 'numeric', timeZone: tzc });
      var fWk = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: tzc });
      var after = function (n) {
        var d = new Date(Date.now() + n * 864e5);
        if (fWk.format(d) === 'Fri') d = new Date(d.getTime() + 864e5);
        return '<b>' + fDay.format(d) + ' ' + fD.format(d) + '/' + fM.format(d) + '</b>';
      };
      uoEtaHtml = isArDoc ? 'هيوصلك بين ' + after(3) + ' و' + after(7) : 'Arrives ' + after(3) + ' – ' + after(7);
      document.querySelectorAll('[data-uo-eta]').forEach(function (el) { el.innerHTML = uoEtaHtml; });
    } catch (err) {}
  }

  /* ---------- 8. دواير الأقسام: الصف بيتحرّك على القسم الحالي ---------- */
  document.querySelectorAll('[data-uo-chips]').forEach(function (nav) {
    var row = nav.querySelector('.uo-chips__l');
    var on = nav.querySelector('.is-on');
    if (!row || !on) return;
    var rr = row.getBoundingClientRect();
    var or = on.getBoundingClientRect();
    row.scrollLeft += (or.left + or.right) / 2 - (rr.left + rr.right) / 2;
  });

  /* ---------- 9. «اختاري اللون/الشكل» (data-uo-choose): شيت اختيار سريع من تحت ----------
     كروت الرئيسية (snippets/uokids-card-atc + sections/uokids-product-cards): بدل ما الزرار يفتح صفحة
     المنتج، بيطلع شيت فيه صورة الاختيار وسعره، الألوان/الأشكال بالصور، الكمية، و«أضيفي للسلة» —
     وبعد الإضافة شيت السلة بيفتح لوحده (Shopify.actions.updateCart). البيانات من /products/<handle>.js
     وبتبدأ تتحمّل أول ما الصباع يلمس الزرار. لو أي حاجة فشلت بيفتح صفحة المنتج عادي. */
  var T = isArDoc
    ? { add: 'أضيفي للسلة', sold: 'الاختيار ده خلصان', more: 'كل تفاصيل المنتج', close: 'إغلاق', save: 'وفّري ', egp: ' جنيه' }
    : { add: 'Add to cart', sold: 'Sold out', more: 'Full product details', close: 'Close', save: 'Save ', egp: ' EGP' };
  var truckSvg = '<svg class="uo-ic" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 10h3.6l2.9 3v2.5h-6.5z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var qcCache = {};
  var qcUrl = function (u) { return (u || '').split('#')[0].split('?')[0]; };
  var qcFetch = function (u) {
    if (!qcCache[u]) {
      qcCache[u] = fetch(u + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
      qcCache[u].catch(function () { delete qcCache[u]; });
    }
    return qcCache[u];
  };
  var esc = function (v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var money = function (cents) {
    var n = (cents || 0) / 100;
    return 'LE ' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var sized = function (src, w) {
    if (src && typeof src === 'object') src = src.src || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  var sameOpts = function (v, sel) {
    return (v.options || []).every(function (o, j) { return o === sel[j]; });
  };
  var qc = null;
  var qs = null;

  var qcPaint = function () {
    if (!qc || !qs) return;
    var vs = qs.p.variants || [];
    var v = vs.filter(function (x) { return sameOpts(x, qs.sel); })[0];
    qs.v = v;
    qc.querySelectorAll('.uo-qc__v').forEach(function (b) {
      var i = +b.getAttribute('data-qc-i');
      var val = b.getAttribute('data-qc-val');
      var on = qs.sel[i] === val;
      var t = qs.sel.slice();
      t[i] = val;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-out', !vs.some(function (x) { return x.available && sameOpts(x, t); }));
    });
    qc.querySelectorAll('[data-qc-label]').forEach(function (el) {
      el.textContent = qs.sel[+el.getAttribute('data-qc-label')] || '';
    });
    var cur = v || vs[0];
    if (!cur) return;
    var cmp = cur.compare_at_price > cur.price ? cur.compare_at_price : 0;
    qc.querySelector('.uo-qc__price b').textContent = money(cur.price);
    qc.querySelector('.uo-qc__price s').textContent = cmp ? money(cmp) : '';
    var sv = qc.querySelector('.uo-qc__save');
    sv.hidden = !cmp;
    if (cmp) sv.textContent = T.save + Math.round((cmp - cur.price) / 100).toLocaleString('en-US') + T.egp;
    var img = (cur.featured_image && cur.featured_image.src) || qs.p.featured_image;
    if (img) qc.querySelector('.uo-qc__img').src = sized(img, 240);
    var ok = !!(v && v.available);
    var add = qc.querySelector('.uo-qc__add');
    add.disabled = !ok;
    add.querySelector('.uo-qc__add-t').textContent = ok ? T.add : T.sold;
    add.querySelector('small').textContent = ok ? money(cur.price * qs.qty) : '';
    qc.querySelector('.uo-qc__qty output').textContent = qs.qty;
  };

  var qcPick = function (i, val) {
    if (!qs) return;
    var vs = qs.p.variants || [];
    var sel = qs.sel.slice();
    sel[i] = val;
    // لو التركيبة دي خلصانة، نختار أقرب تركيبة متاحة بنفس القيمة اللي اتداس عليها
    if (!vs.some(function (x) { return x.available && sameOpts(x, sel); })) {
      var alt = vs.filter(function (x) { return x.available && x.options[i] === val; })[0];
      if (alt) sel = alt.options.slice();
    }
    qs.sel = sel;
    qcPaint();
  };

  var qcAdd = function () {
    if (!qc || !qs || !qs.v || !qs.v.available) return;
    var add = qc.querySelector('.uo-qc__add');
    if (add.classList.contains('is-busy')) return;
    add.classList.add('is-busy');
    var v = qs.v;
    var qty = qs.qty;
    var u = qs.u;
    var fail = function () {
      add.classList.remove('is-busy');
      location.href = u + '?variant=' + v.id;
    };
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      // الشيت بينزل وشيت السلة بيطلع مكانه (بيفتح لوحده مع الإضافة)
      closeSheet(qc);
      actions.updateCart({ lines: [{ merchandiseId: String(v.id), quantity: qty }] }).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) return fail();
        add.classList.remove('is-busy');
      }, fail);
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
      }).then(function (r) { if (r.ok) location.href = '/cart'; else fail(); }, fail);
    }
  };

  var qcBuild = function () {
    var dl = document.createElement('dialog');
    dl.className = 'uo-sheet uo-qc';
    dl.id = 'uo-qc';
    dl.setAttribute('aria-labelledby', 'uo-qc-title');
    dl.setAttribute('autofocus', ''); // الفوكس على الشيت نفسه مش على أول لينك جوّاه
    dl.innerHTML =
      '<div class="uo-sheet__head uo-qc__head" data-uo-sheet-drag>' +
        '<span class="uo-sheet__handle" aria-hidden="true"></span>' +
        '<img class="uo-qc__img" alt="" width="80" height="80">' +
        '<div class="uo-qc__info">' +
          '<a class="uo-qc__title" id="uo-qc-title" href="#"></a>' +
          '<p class="uo-qc__price"><b></b> <s></s></p>' +
          '<p class="uo-qc__save" hidden></p>' +
        '</div>' +
        '<button type="button" class="uo-sheet__x" data-uo-sheet-close aria-label="' + T.close + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '</div>' +
      '<div class="uo-sheet__body uo-qc__body">' +
        '<div class="uo-qc__opts"></div>' +
        (uoEtaHtml ? '<p class="uo-qc__eta">' + truckSvg + '<span>' + uoEtaHtml + '</span></p>' : '') +
        '<a class="uo-qc__more" href="#">' + T.more + '</a>' +
      '</div>' +
      '<div class="uo-qc__foot">' +
        '<div class="uo-qc__qty" role="group">' +
          '<button type="button" data-qc-q="-1" aria-label="-">−</button><output aria-live="polite">1</output><button type="button" data-qc-q="1" aria-label="+">+</button>' +
        '</div>' +
        '<button type="button" class="uo-qc__add"><span class="uo-qc__add-t">' + T.add + '</span><small></small></button>' +
      '</div>';
    document.body.appendChild(dl);
    dl.addEventListener('click', function (e) {
      var v = e.target.closest('[data-qc-i]');
      if (v) {
        qcPick(+v.getAttribute('data-qc-i'), v.getAttribute('data-qc-val'));
        return;
      }
      var q = e.target.closest('[data-qc-q]');
      if (q && qs) {
        qs.qty = Math.max(1, Math.min(20, qs.qty + +q.getAttribute('data-qc-q')));
        qcPaint();
        return;
      }
      if (e.target.closest('.uo-qc__add')) qcAdd();
    });
    return dl;
  };

  var qcRender = function (p, u) {
    var vs = p.variants || [];
    var opts = (p.options || []).map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      var values = o && o.values
        ? o.values
        : vs.map(function (v) { return v.options[i]; }).filter(function (x, k, a) { return a.indexOf(x) === k; });
      return { name: name, values: values };
    });
    var first = vs.filter(function (v) { return v.available; })[0] || vs[0];
    qs = { p: p, u: u, sel: first ? first.options.slice() : [], qty: 1, v: first };
    var html = '';
    opts.forEach(function (o, i) {
      var imgs = o.values.map(function (val) {
        var hit = vs.filter(function (x) { return x.options[i] === val && x.featured_image; })[0];
        return hit ? hit.featured_image.src || '' : '';
      });
      var useImg = imgs.every(Boolean) && imgs.filter(function (x, k, a) { return a.indexOf(x) === k; }).length === imgs.length;
      html += '<fieldset class="uo-qc__opt"><legend>' + esc(o.name) + ': <span data-qc-label="' + i + '"></span></legend><div class="uo-qc__vals">';
      o.values.forEach(function (val, k) {
        html +=
          '<button type="button" class="uo-qc__v' + (useImg ? ' has-img' : '') + '" data-qc-i="' + i + '" data-qc-val="' + esc(val) + '" aria-pressed="false">' +
          (useImg ? '<img src="' + esc(sized(imgs[k], 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<span>' + esc(val) + '</span></button>';
      });
      html += '</div></fieldset>';
    });
    qc.querySelector('.uo-qc__opts').innerHTML = html;
    var title = qc.querySelector('.uo-qc__title');
    title.textContent = p.title;
    title.href = u;
    qc.querySelector('.uo-qc__more').href = u;
    qc.classList.remove('is-loading');
    qcPaint();
  };

  var qcOpen = function (url, trigger) {
    var u = qcUrl(url);
    if (!u) return;
    if (!qc) qc = qcBuild();
    qs = null;
    qc.classList.add('is-loading');
    qc.querySelector('.uo-qc__opts').innerHTML = '';
    qc.querySelector('.uo-qc__price b').textContent = '';
    qc.querySelector('.uo-qc__price s').textContent = '';
    qc.querySelector('.uo-qc__save').hidden = true;
    qc.querySelector('.uo-qc__add').disabled = true;
    qc.querySelector('.uo-qc__add small').textContent = '';
    // صورة واسم الكارت على طول لحد ما البيانات توصل
    var card = trigger && trigger.closest('article, li, [class*="card"], [class*="item"]');
    var cardImg = card && card.querySelector('img');
    var im = qc.querySelector('.uo-qc__img');
    if (cardImg && (cardImg.currentSrc || cardImg.src)) im.src = cardImg.currentSrc || cardImg.src;
    else im.removeAttribute('src');
    var lbl = (trigger && trigger.getAttribute('aria-label')) || '';
    qc.querySelector('.uo-qc__title').textContent = lbl.indexOf(' — ') > -1 ? lbl.split(' — ').slice(1).join(' — ') : '';
    openSheet(qc);
    qcFetch(u).then(function (p) {
      if (qc.open) qcRender(p, u);
    }).catch(function () {
      location.href = url;
    });
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-uo-choose]');
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    qcOpen(t.getAttribute('data-uo-choose') || t.getAttribute('href'), t);
  });
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest && e.target.closest('[data-uo-choose]');
    if (t) qcFetch(qcUrl(t.getAttribute('data-uo-choose') || t.getAttribute('href'))).catch(function () {});
  }, { passive: true });

  /* ---------- 10. نافذة الاختيار السريع بتاعة Horizon (صفحات الأقسام): اسحبي لتحت عشان تقفلي ---------- */
  var qd = null;
  document.addEventListener('touchstart', function (e) {
    var dl = e.target.closest && e.target.closest('dialog.quick-add-modal[open]');
    if (!dl || !mobile.matches) return;
    var y = e.touches[0].clientY;
    if (y - dl.getBoundingClientRect().top > 48 || e.target.closest('button, a, input, label, select')) return;
    qd = { dl: dl, y: y, dy: 0 };
    dl.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!qd) return;
    qd.dy = Math.max(0, e.touches[0].clientY - qd.y);
    qd.dl.style.transform = 'translateY(' + qd.dy + 'px)';
  }, { passive: true });
  var qdEnd = function () {
    if (!qd) return;
    var s3 = qd;
    qd = null;
    s3.dl.style.transition = 'transform .22s ease';
    if (s3.dy > 90) {
      var comp = s3.dl.closest('quick-add-dialog');
      if (comp && typeof comp.closeDialog === 'function') comp.closeDialog();
      else s3.dl.close();
      setTimeout(function () { s3.dl.style.transform = ''; s3.dl.style.transition = ''; }, 380);
    } else {
      s3.dl.style.transform = '';
      setTimeout(function () { s3.dl.style.transition = ''; }, 240);
    }
  };
  document.addEventListener('touchend', qdEnd);
  document.addEventListener('touchcancel', qdEnd);
})();
